import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children } from 'react';
import { Box, Badge as ChakraBadge } from '@chakra-ui/react';
import { ThemeSpaceVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
import { Icon } from '@caspeco/casper-ui-library.components.icon';
import { IconSizeConstants, checkChildRendersToString } from './badge.helper';
function InternalBadge({ icon, ...props }) {
    const { size, children } = props;
    const iconSize = IconSizeConstants[size ?? 'md'];
    const iconElement = icon ? _jsx(Icon, { size: iconSize, icon: icon }) : null;
    const validChildren = [];
    Children.forEach(children, (child) => {
        if (checkChildRendersToString(child))
            validChildren.push(child);
        else
            throw new Error(`Badge component: Invalid return type of children, must return string`);
    });
    return (_jsx(ChakraBadge, { ...props, children: _jsxs(Box, { display: "flex", flexDirection: "row", gap: ThemeSpaceVariable.XSmall, justifyContent: "center", alignItems: "center", children: [iconElement, children] }) }));
}
export const Badge = ({ solid, ...props }) => (_jsx(InternalBadge, { variant: solid ? 'neutralSolid' : 'neutral', ...props }));
Badge.Primary = ({ solid, ...props }) => (_jsx(InternalBadge, { variant: solid ? 'primarySolid' : 'primary', ...props }));
Badge.Secondary = ({ solid, ...props }) => (_jsx(InternalBadge, { variant: solid ? 'secondarySolid' : 'secondary', ...props }));
Badge.Success = ({ solid, ...props }) => (_jsx(InternalBadge, { variant: solid ? 'successSolid' : 'success', ...props }));
Badge.Error = ({ solid, ...props }) => (_jsx(InternalBadge, { variant: solid ? 'errorSolid' : 'error', ...props }));
Badge.Warning = ({ solid, ...props }) => (_jsx(InternalBadge, { variant: solid ? 'warningSolid' : 'warning', ...props }));
Badge.Info = ({ solid, ...props }) => (_jsx(InternalBadge, { variant: solid ? 'infoSolid' : 'info', ...props }));
//# sourceMappingURL=badge.js.map